import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { DetailsModel } from '@core/components/ui-clinng-status-alert/ui-clinng-status-alert.component';
import type { TicketDetails } from '@core/components/ui-clinng-ticket-info/ui-clinng-ticket-info.component';
import { UiClinngStaticHeaderComponent } from '@core/components/ui-clinng-static-header/ui-clinng-static-header.component';
import { UiClinngStatusAlertComponent } from '@core/components/ui-clinng-status-alert/ui-clinng-status-alert.component';
import { UiClinngTicketInfoComponent } from '@core/components/ui-clinng-ticket-info/ui-clinng-ticket-info.component';

@Component({
  selector: 'download-nequi-voucher',
  standalone: true,
  imports: [
    CommonModule,
    UiClinngStaticHeaderComponent,
    UiClinngStatusAlertComponent,
    UiClinngTicketInfoComponent,
  ],
  templateUrl: './download-nequi-voucher.component.html',
  styleUrl: './download-nequi-voucher.component.scss',
})
export class DownloadNequiVoucherComponent {
  @Input() detailsModel!: DetailsModel;
  @Input() operationInfo: any;
  @Input() ticketDetails: TicketDetails[] = [];
}
